import { DecoupledEditor } from 'ckeditor5';
import { Ref, ref } from 'vue';

/**
 * This is a global variable, because we need it globally, and it needs to be non-reactive.
 * Vuex state vars are always reactive and Object.freeze can mess up the editor instance.
 */
const activeEditor: Ref<DecoupledEditor | HTMLTextAreaElement | null> = ref(null);

const setActiveEditor = (editor: DecoupledEditor | HTMLTextAreaElement | null) => (activeEditor.value = editor);

export { activeEditor, setActiveEditor };
